import { render } from "./YellowConsultantRegistration.vue?vue&type=template&id=5c684542"
import script from "./YellowConsultantRegistration.vue?vue&type=script&lang=js"
export * from "./YellowConsultantRegistration.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__